import { Component, input, model, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export interface Tab {
  id: string;
  /** Translation key (mark it with `_()`); text without a translation shows as is. */
  label: string;
}

@Component({
  selector: 'andor-tabs',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './tabs.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './tabs.scss',
})
export class Tabs implements OnInit {
  tabs = input<Tab[]>([]);
  active = model<Tab>();
  constructor() {}
  ngOnInit(): void {
    if (!this.active() && this.tabs().length > 0) {
      this.active.set(this.tabs()[0]);
    }
  }
}
